export const SERVICE_ID = '59fface5-c76c-446c-bb58-15b110578a87';

export const CLIENT_ID = '2a508433-c2ba-41ef-be29-a7e51ead9904';
export const CLIENT_NAME = 'Bymeldingportal_2.0';

export const CLIENT_VILKAAR_ID = '8dc9bb1f-6856-4541-8b3f-881ef0d4fc30';
